var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 11.5834C10.8748 11.5834 11.5837 10.8745 11.5837 10.0001C11.5837 9.12563 10.8748 8.41675 10.0003 8.41675C9.12587 8.41675 8.41699 9.12563 8.41699 10.0001C8.41699 10.8745 9.12587 11.5834 10.0003 11.5834Z",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 11.5834C16.7078 11.5834 17.4167 10.8745 17.4167 10.0001C17.4167 9.12563 16.7078 8.41675 15.8333 8.41675C14.9589 8.41675 14.25 9.12563 14.25 10.0001C14.25 10.8745 14.9589 11.5834 15.8333 11.5834Z",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16634 11.5834C5.04079 11.5834 5.74967 10.8745 5.74967 10.0001C5.74967 9.12563 5.04079 8.41675 4.16634 8.41675C3.29189 8.41675 2.58301 9.12563 2.58301 10.0001C2.58301 10.8745 3.29189 11.5834 4.16634 11.5834Z",
    stroke: "#484964",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.52a4b6e5a4a5557ea6eef81c283e818d.svg";
export { ForwardRef as ReactComponent };